<template functional>
  <div :key="text" :class="{ separator: props.hasSeparator }">
    <component
      :is="props.url ? 'a' : 'div'"
      class="nav-item-link"
      :class="[
        $options.locals[props.level],
        { 'beauty-profile-container': props.badgeText }
      ]"
      :href="props.url"
      v-bind="props.additionalAttrs"
      v-on="listeners.click && !props.url ? { click: listeners.click } : null"
    >
      <slot name="icon">
        <img
          v-if="props.iconSrc && $options.locals[props.level] === 'first'"
          :src="props.iconSrc"
          :alt="props.iconAltText"
          class="icon"
          :class="{ 'get-started-icon': props.isGetStarted }"
        />
      </slot>

      <!--
        @slot navbar text can be overridden, because those that have children need to have data-analytics -->
      <slot name="nav-bar-text" classes="nav-bar-text" :text="props.text">
        <span class="nav-bar-text">
          {{ props.text }}
        </span>
        <span v-if="props.description" class="nav-bar-description">
          {{ props.description }}
        </span>
        <span v-if="props.badgeText" class="new-tag">
          {{ props.badgeText }}
        </span>
      </slot>
    </component>
  </div>
</template>

<script>
export default {
  name: 'SidebarNavItem',

  locals: {
    1: 'first',
    2: 'second',
    3: 'third'
  },

  props: {
    /** Text of menu item */
    text: {
      type: String,
      required: true
    },
    /** Description of menu item */
    description: {
      type: String,
      default: null
    },
    /** Url to direct to on click */
    url: {
      type: String,
      default: null
    },
    /** Level of menu item. Can be 1, 2 or 3. Css varies for each level */
    level: {
      type: Number,
      required: true,
      validator: function (value) {
        return [1, 2, 3].indexOf(value) !== -1
      }
    },
    /** Boolean value for whether the item has a separator or not */
    hasSeparator: {
      type: Boolean,
      default: true
    },
    /** Source of icon for some of the menu elements */
    iconSrc: {
      type: String,
      default: null
    },
    /** Alt text for icon */
    iconAltText: {
      type: String,
      default: ''
    },
    /** Boolean value for whether the icon is a get started icon */
    isGetStarted: {
      type: Boolean,
      default: false
    },
    additionalAttrs: {
      type: Object,
      default: () => {}
    },
    /** Text for badge*/
    badgeText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item-link {
  display: block;
  padding: 10px 20px 10px;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;

  &:hover {
    color: $black;
    cursor: pointer;
  }

  &.first {
    text-transform: uppercase;
    font-weight: 700;

    .nav-bar-text {
      vertical-align: text-bottom;
    }
  }

  &.second {
    margin-left: 20px;
  }

  &.third {
    margin-left: 40px;
  }
}

.separator {
  border-bottom: 1px solid $grey;

  .nav-item-link {
    padding: 14px 20px 14px;
  }

  .toggle-icon {
    margin-top: 0px;
  }

  .first {
    padding: 15px 20px 10px;
  }
}

.icon {
  vertical-align: bottom;
  height: 30px;
  width: 30px;
  margin-right: 15px;
}

.get-started-icon {
  vertical-align: top;
  height: 16px;
  width: 15px;
  margin-right: 5px;
}

.nav-bar-description {
  display: block;
  font-size: 13px;
  color: $grey-darker;
}

.beauty-profile-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;

  .new-tag {
    background-color: $red;
    color: $white;
    padding-left: 4px;
    padding-right: 4px;
    border-radius: 4px;
    font-size: 10px;
    line-height: 15px;
    height: 16px;
  }
}
</style>
